// extracted by mini-css-extract-plugin
export default {"wrapper":"flight-request-drone_wrapper__9hq6-","wrapText":"flight-request-drone_wrapText__n7rr0"};